<script setup>
import Helpers from '@/helpers/index.js';
import { useSetupStore } from '@/stores/setup.store.js';
import { useUserStore } from '@/stores/user.store.js';

const account = useSetupStore();
const user = useUserStore();

const socialConnections = [
  { id: 'YouTube', text: 'Authenticate with YouTube' },
  { id: 'Instagram', text: 'Authenticate with Instagram' },
  { id: 'TikTok', text: 'Authenticate with TikTok' }
];
</script>

<template>
  <h3 class="text-primary-blue mb-3">Let's get you connected.</h3>
  <div style="font-size: 13px">Connect to your social channels to help us track your projects better.</div>
  <div class="mt-5">
    <template v-for="connection in socialConnections" :key="connection.id">
      <v-hover>
        <template v-slot:default="{ isHovering, props }">
          <v-card
            @click="user.connectUserChannelWithOAuthPopup(connection.id)"
            height="41"
            v-bind="props"
            class="pa-1 rounded-lg mb-5 d-flex"
            :color="isHovering ? 'primary-blue' : 'undefined'"
            style="box-shadow: 0px 3px 6px #00000029; cursor: pointer"
          >
            <div class="d-flex align-center">
              <div style="width: 25px; height: 25px" class="mr-3">
                <img :src="Helpers.getSocialMediaIcon(connection.id)" :alt="connection.id" style="width: 25px; height: 25px" />
              </div>
              <div class="font-weight-medium" style="font-size: 0.875rem">
                {{ connection.text }}
              </div>
            </div>
          </v-card>
        </template>
      </v-hover>
    </template>
  </div>
  <div class="tw-w-full">
    <div>
      <v-btn
        color="primary-blue"
        size="large"
        rounded="lg"
        block
        flat
        class="text-capitalize font-weight-bold"
        style="letter-spacing: 0px"
        to="/onboard/invite-team"
      >
        Continue
      </v-btn>
      <div class="d-flex justify-space-between text-primary-blue mt-3" style="font-size: 12px">
        <div>
          <RouterLink style="color: #5171ff" to="/onboard">
            <b>Back</b>
          </RouterLink>
        </div>
        <div>
          <RouterLink style="color: #5171ff" to="/onboard/invite-team">
            <b>Skip</b>
          </RouterLink>
        </div>
      </div>
    </div>
    <v-progress-linear class="mt-4" color="primary-blue" model-value="45"></v-progress-linear>
  </div>
</template>

<style scoped></style>
